
$( document ).ready(function() {
$('#ProductSelect-oz1bpld-option-0>div:first-child label').html('3 Pack<br/><em>(for 1x daily)</em>');
$('#ProductSelect-oz1bpld-option-0>div:last-child label').html('6 Pack<br/><em>(for 2x daily)</em>');
$('#ProductSelect-oz1bpld-option-0>div:last-child').append('<span class="nfs-best-saving">Best Value</span>');




});

$(document).ready(function(){
setTimeout(function(){
      //       $('.rc_label__onetime').html('One-time purchase: <b>$54.00</b>');
      $('#AddToCartForm-oz1bpld .sub_percent').text('(30%)');
      $('#AddToCartForm-oz1bpld .sub_price').text('$63.00');
      $('#AddToCartForm-oz1bpld .sub_percent').attr("id","subpercent");
  $('#AddToCartForm-oz2bpld .sub_percent').attr("id","subpercent");
      $('.sub_percent').removeAttr('id');
      $('#AddToCartForm-oz1bpld .sub_price').removeAttr("data-rtx-subscription-price");
      $('#AddToCartForm-oz1bpld .rtx_strike').removeAttr("data-rtx-onetime-price");
     
      
      $('#AddToCartForm-oz1bpld .rtx-subscription-label .rtxshotsubprice').text('($2.63 per Dose shot)');
       $('#AddToCartForm-oz1bpld .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.63 per Dose shot)');
      $('#AddToCartForm-oz1bpld .rtx-subscription-label .rtxshotsubprice').removeClass('rtx-shot-sub-price');
      $('#AddToCartForm-oz2bpld .rtx-subscription-label .rtxshotsubprice').removeClass('rtx-shot-sub-price');
      $('#AddToCartForm-oz1bpld .onetime .rtx-shot-one-price').text('($3.75 per Dose shot)');
      $('#AddToCartForm-oz2bpld .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.88 per Dose shot)');
      $('#AddToCartForm-oz2bpld .rtx-subscription>div>label:last-child .onetime .rtxshotsubprice').text('($4.13 per Dose shot)');
   
    $('#AddToCartForm-oz1bpld .onetime .rtx-shot-one-price .igPrice').text('$3.75');
   
 
}, 300);

});
$(document).ready(function(){
setTimeout(function(){
$('.rc_label__deliver_every').after('<p class="nfs-nocomitment">No commitment, cancel anytime</p>');
}, 300);

});

$("#ProductSelect-oz1bpld-option-0>div:first-child").click(function() {
$('#purchaseTypeSubscription-7697614143729---AddToCartForm-oz1bpld').click();
setTimeout(function(){     
$('#AddToCartForm-oz1bpld .sub_percent').text('(30%)');
$('#AddToCartForm-oz1bpld .sub_price').text('$63.00');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-oz1bpld .rtx_strike').text('$90.00');
$('#AddToCartForm-oz1bpld .rtx_strike').removeAttr("data-rtx-onetime-price");
  $('#AddToCartForm-oz1bpld .rtx-subscription-label .rtxshotsubprice').text('($2.63 per Dose shot)');
  
$('#AddToCartForm-oz1bpld .onetime .rtx-shot-one-price').text('($3.75 per Dose shot)');
$('.oz1price').html('<strike>$90.00</strike> $76.50');
$('.oz3price').html('<strike>$90.00</strike> $76.50');
$('#AddToCartForm-oz1bpld .onetime .rtx-shot-one-price .igPrice').text('$3.75');
}, 300);
});    

$("#ProductSelect-oz1bpld-option-0>div:last-child").click(function() {
$('#purchaseTypeSubscription-7697614143729---AddToCartForm-oz1bpld').click();
setTimeout(function(){     
$('#AddToCartForm-oz1bpld .sub_percent').text('(30%)');
$('#AddToCartForm-oz1bpld .sub_price').text('$112.00');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-oz1bpld .rtx_strike').text('$160.00');
$('#AddToCartForm-oz1bpld .rtx_strike').removeAttr("data-rtx-onetime-price");
  $('#AddToCartForm-oz1bpld .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.33 per Dose shot)');
$('#AddToCartForm-oz1bpld .onetime .rtx-shot-one-price').text('($3.33 per Dose shot)');
$('.oz1price').html('<strike>$160.00</strike> $136.00');
$('.oz3price').html('<strike>$160.00</strike> $136.00');

}, 300);
});




jQuery('.oztab>span:first-child').click(function() {
    $(this).addClass('active');
    $('.oztab>span:last-child').removeClass('active');
    $('#AddToCartForm-oz1bpld').show();
    $('#AddToCartForm-oz2bpld').hide();
 
    $('.main-pr1').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1_84e07148-2221-4ad4-89c0-2ca6334e09d1_2000x.png?v=1748868498");
    $('.main-pr11').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1_84e07148-2221-4ad4-89c0-2ca6334e09d1_2000x.png?v=1748868498");
      $('.edumrp').text('$63.00');
    $('.edusp').text('$63.00');
   $('.gdi').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/AMZ07_LIVER_SFP_PDP_e8f2d9b3-57be-4e70-b508-499baf11fa96.jpg?v=1760250143");
  
  
$('.oz1price').html('<strike>$90.00</strike> $76.50');
 $('#AddToCartForm-oz1bpld .onetime .rtx-shot-one-price .igPrice').text('$3.75');
  });

jQuery('.oztab>span:last-child').click(function() {
      $(this).addClass('active');
      $('.oztab>span:first-child').removeClass('active');
      $('#AddToCartForm-oz1bpld').hide();
      $('#AddToCartForm-oz2bpld').show();
      $('.main-pr1').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1C_1_2000x.png?v=1748868678");
      $('.main-pr11').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1C_1_2000x.png?v=1748868678");
      $('#AddToCartForm-oz2bpld .sub_percent').text('(30%)');
      $('#AddToCartForm-oz2bpld .sub_price').text('$69.30');
   $('#AddToCartForm-oz2bpld .sub_price').removeAttr("data-rtx-subscription-price");
      $('#AddToCartForm-oz2bpld .rtx_strike').removeAttr("data-rtx-onetime-price");
     
      $('#AddToCartForm-oz2bpld .sub_price').removeClass('sub_price');
      $('#AddToCartForm-oz2bpld .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.88 per Dose shot)');
      $('#AddToCartForm-oz2bpld .rtx-subscription>div>label:first-child .rtxshotsubprice').removeClass('rtx-shot-one-price');;
      
      $('#AddToCartForm-oz2bpld .rtx-subscription>div>label:last-child .rtx-shot-one-price').text('($4.13 per Dose shot)');
      $('.edumrp').text('$99.00');
      $('.edusp').text('$69.30');
       $('.gdi').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/W10_Liver_2oz.png?v=1760457033");

      $('.oz3price').html('<strike>$99.00</strike> $84.15');
    
});

  jQuery('#ProductSelect-oz1bpld-option-0>div:first-child').click(function() {
 $('.main-pr1').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1B.png?v=1748868497");
    $('.main-pr11').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1B.png?v=1748868497");

  });
  jQuery('#ProductSelect-oz1bpld-option-0>div:nth-child(2)').click(function() {
 $('.main-pr1').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1_84e07148-2221-4ad4-89c0-2ca6334e09d1.png?v=1748868498");
     $('.main-pr11').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1_84e07148-2221-4ad4-89c0-2ca6334e09d1.png?v=1748868498");

  });



 



jQuery('.pr-img1 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr1').attr('src', thissrc);
jQuery('.pr-img1 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});

jQuery('.pr-img4 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr4').attr('src', thissrc);
jQuery('.pr-img4 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});

$(document).ready(function(){
setTimeout(function(){
$('.nfs-nocomitment').html('<ul><li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>Save 15% on recurring orders</span></li><li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>Unlock long-term liver health* by drinking 2-4 ounces a day!</span></li></li> <li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>No commitments! Adjust or cancel anytime</span></li> <li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>30-Day Money-back Guarantee**</span></li></ul>');
}, 2000);
});


$(".liveraction").click(function() {
  $(this).toggleClass('flipcardliveri');
$(this).children('.liveraction-inner').toggleClass('flipcardliver');
});


$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 50
    }, 500);
});